import * as React from 'react';
import { AccountContentCalendar } from '../../containers/account/AccountContentCalendar';

export const AdminAccountContentCalendarPage: React.FC = () => {
	return <AccountContentCalendar />;
};
